import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'medsurf-slide-wysiwyg-pois',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './pois.component.html',
    styleUrls: ['./pois.component.scss'],
    standalone: false
})
export class PoisComponent {
  readonly FlatModels = FlatModels;

  constructor(public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public translate: TranslateService) {
  }
  
  trackByPoi(index: number,
             item: FlatModels.PointOfInterestEntityModels.PointOfInterest) {
    return item.id + item.order || index;
  }
}
